import React, { memo } from 'react';
import EvtNaviType2 from '@wconcept/wconcept-ui/components/molecules/_content/EvtNaviType2';
import useCommonNavigationModule from '@hooks/useCommonNavigationModule';

interface CommonNavigationModuleProps {
  navigationId: number;
  promotionId: number;
  promotionTitle: string;
  isDesktop?: boolean;
}

function CommonNavigationModule({
  navigationId,
  promotionId,
  promotionTitle,
  isDesktop,
}: CommonNavigationModuleProps) {
  const { items } = useCommonNavigationModule({
    navigationId,
    promotionId,
    promotionTitle,
  });
  return <EvtNaviType2 isDesktop={isDesktop} items={items} />;
}

export default memo(CommonNavigationModule);
